import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const shouldShowCard = (items) => Array.isArray(items) && items.some((item) => item?.value !== null && item?.value !== undefined && String(item.value) !== '');

export const VirtualPosPaymentDetailContent = ({
  summary,
  identifiers,
  customerItems,
  collectionItems,
  chargeItems,
  orderItems,
  deposits,
  metadataText,
  metadataExtraItems,
  extraContent,
}) => {
  const hasIdentifiers = shouldShowCard(identifiers);
  const hasCustomer = shouldShowCard(customerItems);
  const hasCollection = shouldShowCard(collectionItems);
  const hasCharge = shouldShowCard(chargeItems);
  const hasOrder = shouldShowCard(orderItems);
  const hasDeposits = Array.isArray(deposits) && deposits.length > 0;
  const hasMetadataExtra = shouldShowCard(metadataExtraItems);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1">
          <p className="text-sm font-medium text-gray-500">{summary?.orderIdLabel || 'ID de Orden (VirtualPOS)'}</p>
          <p className="text-lg font-mono break-all">{summary?.orderId || '-'}</p>
        </div>
        <div className="space-y-1 text-right">
          <p className="text-sm font-medium text-gray-500">{summary?.amountLabel || 'Monto'}</p>
          <p className="text-2xl font-bold text-gray-900">{summary?.amount || '-'}</p>
        </div>
        <div className="space-y-1">
          <p className="text-sm font-medium text-gray-500">{summary?.statusLabel || 'Estado'}</p>
          <div>{summary?.status || '-'}</div>
        </div>
        <div className="space-y-1 text-right">
          <p className="text-sm font-medium text-gray-500">{summary?.dateLabel || 'Fecha'}</p>
          <p className="text-gray-900">{summary?.date || '-'}</p>
        </div>
      </div>

          {hasIdentifiers && (
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">Identificadores de Transacción</CardTitle>
              </CardHeader>
              <CardContent className="text-xs sm:text-sm grid grid-cols-2 gap-2">
                {identifiers.map((item, idx) => (
                  item?.value !== null && item?.value !== undefined && String(item.value) !== '' ? (
                    <React.Fragment key={`${item.label}-${idx}`}>
                      <span className="text-gray-500">{item.label}</span>
                      <span className={item.mono ? 'font-mono break-all' : 'font-medium break-all'}>{item.value}</span>
                    </React.Fragment>
                  ) : null
                ))}
              </CardContent>
            </Card>
          )}

          {hasCustomer && (
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">Información del Cliente</CardTitle>
              </CardHeader>
              <CardContent className="text-sm">
                <div className="grid grid-cols-2 gap-2">
                  {customerItems.map((item, idx) => (
                    item?.value !== null && item?.value !== undefined && String(item.value) !== '' ? (
                      <React.Fragment key={`${item.label}-${idx}`}>
                        <span className="text-gray-500">{item.label}</span>
                        <span className={item.mono ? 'font-mono break-all' : 'font-medium break-all'}>{item.value}</span>
                      </React.Fragment>
                    ) : null
                  ))}
                </div>
              </CardContent>
            </Card>
          )}

          {hasCollection && (
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">Detalles de Recaudación (VirtualPOS)</CardTitle>
              </CardHeader>
              <CardContent className="text-sm space-y-2">
                <div className="grid grid-cols-2 gap-2">
                  {collectionItems.map((item, idx) => (
                    item?.value !== null && item?.value !== undefined && String(item.value) !== '' ? (
                      <React.Fragment key={`${item.label}-${idx}`}>
                        <span className={item.boldLabel ? 'text-gray-500 font-bold' : 'text-gray-500'}>{item.label}</span>
                        <span className={item.className || (item.mono ? 'font-mono break-all' : 'font-medium break-all')}>{item.value}</span>
                      </React.Fragment>
                    ) : null
                  ))}
                </div>
              </CardContent>
            </Card>
          )}

          {hasCharge && (
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">Charge (VirtualPOS)</CardTitle>
              </CardHeader>
              <CardContent className="text-sm">
                <div className="grid grid-cols-2 gap-2">
                  {chargeItems.map((item, idx) => (
                    item?.value !== null && item?.value !== undefined && String(item.value) !== '' ? (
                      <React.Fragment key={`${item.label}-${idx}`}>
                        <span className="text-gray-500">{item.label}</span>
                        <span className={item.className || (item.mono ? 'font-mono break-all' : 'font-medium break-all')}>{item.value}</span>
                      </React.Fragment>
                    ) : null
                  ))}
                </div>
              </CardContent>
            </Card>
          )}

          {(hasOrder || hasDeposits) && (
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">Order (VirtualPOS)</CardTitle>
              </CardHeader>
              <CardContent className="text-sm space-y-3">
                {hasOrder && (
                  <div className="grid grid-cols-2 gap-2">
                    {orderItems.map((item, idx) => (
                      item?.value !== null && item?.value !== undefined && String(item.value) !== '' ? (
                        <React.Fragment key={`${item.label}-${idx}`}>
                          <span className="text-gray-500">{item.label}</span>
                          <span className={item.className || (item.mono ? 'font-mono break-all' : 'font-medium break-all')}>{item.value}</span>
                        </React.Fragment>
                      ) : null
                    ))}
                  </div>
                )}

                {hasDeposits ? (
                  <div className="space-y-2">
                    <div className="text-sm font-medium text-gray-600">Depósitos ({deposits.length})</div>
                    <div className="rounded-md border overflow-auto">
                      <table className="w-full text-sm">
                        <thead className="bg-white">
                          <tr>
                            <th className="text-left p-2 font-medium">Descripción</th>
                            <th className="text-left p-2 font-medium">Payout Date</th>
                            <th className="text-left p-2 font-medium">Payout Amount</th>
                            <th className="text-left p-2 font-medium">Processing Fee</th>
                            <th className="text-left p-2 font-medium">Flat Fee</th>
                          </tr>
                        </thead>
                        <tbody>
                          {deposits.map((deposit, idx) => (
                            <tr key={`${deposit?.payout_date || ''}-${idx}`} className="border-t">
                              <td className="p-2">{deposit?.description || '-'}</td>
                              <td className="p-2">{deposit?.payout_date || '-'}</td>
                              <td className="p-2">{deposit?.payout_amount || '-'}</td>
                              <td className="p-2">{deposit?.processing_fee || '-'}</td>
                              <td className="p-2">{deposit?.processing_flat_fee || '-'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
              </CardContent>
            </Card>
          )}

          {extraContent || null}

          {(metadataText || hasMetadataExtra) && (
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">Metadata</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="rounded-md border bg-white p-3 overflow-auto max-h-[50vh]">
                  <pre className="text-xs whitespace-pre-wrap break-words">{metadataText || 'Sin metadata'}</pre>
                </div>
                {hasMetadataExtra ? (
                  <div className="mt-3 grid grid-cols-2 gap-2 text-xs sm:text-sm">
                    {metadataExtraItems.map((item, idx) => (
                      item?.value !== null && item?.value !== undefined && String(item.value) !== '' ? (
                        <React.Fragment key={`${item.label}-${idx}`}>
                          <span className="text-gray-500">{item.label}</span>
                          <span className={item.className || (item.mono ? 'font-mono break-all' : 'font-medium break-all')}>{item.value}</span>
                        </React.Fragment>
                      ) : null
                    ))}
                  </div>
                ) : null}
              </CardContent>
            </Card>
          )}
    </div>
  );
};

const VirtualPosPaymentDetailDialog = ({
  trigger,
  headerRight,
  summary,
  identifiers,
  customerItems,
  collectionItems,
  chargeItems,
  orderItems,
  deposits,
  metadataText,
  metadataExtraItems,
  extraContent,
}) => (
  <Dialog>
    <DialogTrigger asChild>
      {trigger}
    </DialogTrigger>
    <DialogContent className="w-[95vw] max-w-[108rem] max-h-[90vh] overflow-y-auto bg-white">
      <DialogHeader>
        <div className="flex items-center justify-between gap-3">
          <DialogTitle>Detalle del Pago</DialogTitle>
          {headerRight || null}
        </div>
      </DialogHeader>
      <VirtualPosPaymentDetailContent
        summary={summary}
        identifiers={identifiers}
        customerItems={customerItems}
        collectionItems={collectionItems}
        chargeItems={chargeItems}
        orderItems={orderItems}
        deposits={deposits}
        metadataText={metadataText}
        metadataExtraItems={metadataExtraItems}
        extraContent={extraContent}
      />
    </DialogContent>
  </Dialog>
);

export default VirtualPosPaymentDetailDialog;
